import { defineComponent as _defineComponent } from 'vue';
import Alert from "@/components/Alert.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ClientError',
    props: {
        error: null
    },
    setup(__props) {
        const props = __props;
        // TODO -- Pretty this up a bit so it's not just a barebones Alert, include
        // general client error verbiage and admin/help contact protocol below.
        //
        // Right now this is only used as a destination for navigation failures
        // (AdminRequired), but could be used for other client errors that need to be
        // presented to the user interrupting the normal flow and context of the app.
        return { __sfc: true, props, Alert };
    }
});
